import { HttpStatus } from '../constants/http-status';

export const isSuccessful = (status: number) => status >= HttpStatus.OK && status < HttpStatus.MULTIPLE_CHOICES;

export const isUnauthorized = (status: number) => status === HttpStatus.UNAUTHORIZED;

export const shouldRetry = (failureCount: number, error: any) => {
  // Stop after 3 attempts
  if (failureCount >= 3) return false;

  const status = error?.status;

  // Retry on certain status codes
  if ([HttpStatus.REQUEST_TIMEOUT, HttpStatus.TOO_MANY_REQUESTS].includes(status)) return true;
  if (status >= HttpStatus.SERVER_ERROR_RETRY_RANGE_START && status <= HttpStatus.SERVER_ERROR_RETRY_RANGE_END)
    return true;

  // Otherwise, don't retry
  return false;
};
